import { Box } from '@mui/material';

const UnauthorizedPage: React.FC = () => {
    return (
        <Box
            mt={2}
            m={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <img alt="login log" src="logo-192x192.png" />
            <h2 className="uppercase mt-3 text-white mb-4">Unauthorized</h2>
        </Box>
    );
};

export default UnauthorizedPage;
